import { useCallback, useMemo, useState } from "react";

import { ListIcon } from "components";
import { CommonButton } from "pages/Components";
import { Employee } from "pages/Components/EmployeeErrorDialog";
import { useDialog } from "stores/Dialog";
import { checkImportSuccess } from "utils";

const useErrorListDialog = () => {
  const [errorList, setErrorList] = useState<Employee[]>([] as Employee[]);
  const listEmployeeErrorDialog = useDialog({
    name: "ListEmployeeErrorDialog",
  });
  const showButton = useMemo(() => !!errorList?.length, [errorList?.length]);

  const ButtonDownload = useMemo(() => {
    if (showButton) {
      return (
        <CommonButton
          color="error"
          labelI18n="errorList"
          onClick={() => listEmployeeErrorDialog.onToggle({ data: errorList })}
          startIcon={<ListIcon fontSize="small" />}
        />
      );
    }
    return <div />;
  }, [errorList, listEmployeeErrorDialog, showButton]);

  const onReset = useCallback(() => {
    setErrorList([]);
  }, []);

  const handleMappingList = useCallback((data: Record<string, string>[]) => {
    return (
      data.map((item, index) => {
        return {
          rowId: item.rowId || index,
          message: item.message || "",
          code: item?.code || item?.empCode || item?.employeeCode || "",
          fullName:
            item?.fullName || item?.empFullname || item?.employeeName || "",
        };
      }) || []
    );
  }, []);

  const onToggle = useCallback(
    (_errorList: Employee[]) => {
      listEmployeeErrorDialog.onToggle({
        data: _errorList,
      });
      setErrorList(_errorList);
    },
    [listEmployeeErrorDialog]
  );

  return {
    errorList,
    ButtonDownload,
    checkImportSuccess,
    setErrorList,
    onReset,
    handleMappingList,
    onToggle,
  };
};

export default useErrorListDialog;
